











































import {Vue, Component, Prop} from 'vue-property-decorator';
import {PayrollReport} from "@/components/payroll/business/employments/employee/PayrollReport";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import PaystubReport from "@/components/payroll/reports/paystub/PaystubReport.vue";
import {prettyEnum} from "@/utils/StringUtils";
import moment from "moment/moment";

@Component({
	computed: {
		moment() {
			return moment
		}
	},
	methods: {
		prettyEnum(val: string) {
			return prettyEnum(val)
		}
	},
	components: {PaystubReport, BTPortalCollapse}
})
export default class CollapsedPaystubReport extends Vue {
	@Prop()
	private report!: PayrollReport
}
